import { object, number } from "yup";

export const bloodPressureSchema = object({
    systolic: number()
        .typeError("Systolic level must be a number")
        .min(30, "Systolic level must be greater than or equal to 30")
        .max(300, "Systolic level must be less than or equal to 300")
        .required("Systolic is required"),
    diastolic: number()
        .typeError("Diastolic level must be a number")
        .min(10, "Diastolic level must be greater than or equal to 10")
        .max(200, "Diastolic level must be less than or equal to 200")
        .required("Diastolic is required"),
    
});